import React, { useContext, useEffect, useState } from "react";
import { usePointingBoardingContainerStore } from "../../../../store/PointingStore";
import { OperationContext } from "../../CreateOperation";
import { useSearchParams } from "react-router";
import { ColumnItem } from "../../../../../../common/models/table";
import { PointingService } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../../../common/components/Loader/Loader";
import { LFTableV3 } from "../../../../../../common/components/LFTable/LFTableV3";
import { CustomDrawer } from "../../../../../../common/components/Drawer/CustomDrawer";
import { ContainerDetails } from "../details/containerDetails/ContainerDetails";
import { ActionsKey } from "../../../../../../common/models/Actions";
import { useOperationType } from "../../../../core/_context";

export const BoardingContainerPointingList = () => {
  const { initialValue } = useContext(OperationContext);

  const {
    list,
    pageState,
    totalItems,
    setList,
    resetPageState,
    setPageState,
    actioned,
    setActioned,
  } = usePointingBoardingContainerStore();
  const [searchParams] = useSearchParams();
  const movement = searchParams.get("movment");
  const type = searchParams.get("type");

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowDrawer, setIsShowDrawer] = useState<boolean>(false);

  const operationType = useOperationType();

  const cols: ColumnItem[] = [
    {
      key: "reference",
      title: "Référence",
      dataIndex: "reference",
      searchKey: "uniqueIdentifier",
      searchType: "text",
      show: true,
      // isCanSort: true,
    },
    
    {
      key: "containerType",
      title: "Type de conteneur",
      dataIndex: "containerType",
      show: true,
      // isCanSort: true,
      nestedKey: "containerType.abbreviation",
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.abbreviation}</span>
          </div>
        );
      },
    },
    
    ...(operationType === "sales"
      ? [
          {
            key: "inspectionStoragePeriod",
            title: "Pointage entreposage",
            dataIndex: "inspectionStoragePeriod",
            searchType: "date",
            searchKey: "inspectionStorageStartAt",
            show: true,
            isCanSort: true,
            sortKey: "inspectionStorageStartAt",
            defaultSort: "desc",
          } as ColumnItem,
        ]
      : []),

    {
      key: "inspectionDocksidePeriod",
      title: operationType === "sales" ? "Pointage à Quai" : "Pointage",
      dataIndex: "inspectionDocksidePeriod",
      show: true,
      searchType: "date",
      searchKey: "inspectionDocksideStartAt",
      isCanSort: true,
      sortKey: "inspectionDocksideStartAt",
      defaultSort: operationType === "cabotage" ? "desc" : null,
    },
    ...(operationType === "sales"
      ? [
          {
            key: "inspectionOnBoardPeriod",
            title: "Pointage à Bord",
            dataIndex: "inspectionOnBoardPeriod",
            show: true,
            searchType: "date",
            searchKey: "inspectionOnBoardStartAt",
            isCanSort: true,
            sortKey: "inspectionOnBoardStartAt"
          } as ColumnItem,
        ]
      : []), 
      {
        key: "loadFillingStatus",
        title: "Etat",
        dataIndex: "loadFillingStatus",
        nestedKey: "loadFillingStatus.name",
        show: true,
        render: (state: any) => {
          return (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center">
              <span>{state?.name}</span>
            </div>
          );
        },
        // isCanSort: true,
      },
  ];

  useEffect(() => {
    if (!isShowDrawer) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowDrawer]);

  useEffect(() => {
      resetPageState();
    }, [movement, type]);

  useEffect(() => {
    const selected =
      initialValue?.embarkationMovement?.loadPossessionStatus?.find(
        (item: any) => item.id === type?.toUpperCase()
      ) ?? initialValue?.embarkationMovement?.loadPossessionStatus?.[0];

    if (selected && selected?.url && movement) {
      const hasOrder = (() => {
        if (pageState?.order?.dataKey && pageState?.order?.order) {
          return true;
        }
  
        return Object.entries(pageState).some(
          ([key, value]) =>
            key.startsWith("order[") &&
            value !== null &&
            value !== undefined &&
            value !== ""
        );
      })();
  
      if (!hasOrder && !pageState?.__defaultOrderSet) {
        if (operationType === "sales") {
          setPageState({
            ...pageState,
            order: {
              inspectionStorageStartAt: "desc",
            },
            __defaultOrderSet: true,
          });
        } else {
          setPageState({
            ...pageState,
            order: {
              inspectionDocksideStartAt: "desc",
            },
            __defaultOrderSet: true,
          });
        }
        return;
      }

      getMovement(`${selected?.url}/controlled`, {
        ...pageState,
        "movement.id": movement,
        isLoadControlled: true,
        });
      }
  }, [movement, pageState, type]);

  const handleShowDrawer = () => {
    setIsShowDrawer((prev: boolean) => !prev);
  };

  const getMovement = async (url: string, params: any) => {
    try {
      setIsLoading(true);

      const res = await PointingService.getAllMouvement(url, params);

      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      // onDeleteHandler(item?.id);
    } else {
      handleShowDrawer();
      setActioned({
        data: item,
        action,
      });
    }
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <LFTableV3
        columns={cols}
        data={list}
        params={pageState}
        onAction={onActionClick}
        isCanShow={() => true}
        onSearch={setPageState}
        onSort={setPageState}
        onResetSearch={resetPageState}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
        onChangePage={setPageState}
      />
      {isShowDrawer && (
        <CustomDrawer
          isOpen={isShowDrawer}
          onClose={handleShowDrawer}
          title={`${actioned?.action === "read" ? "Détails" : "Modification"}`}
        >
          <ContainerDetails initialValue={actioned?.data} />
        </CustomDrawer>
      )}
    </div>
  );
};
